import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const EmailListLoader = () => (
  <Box display="block" py={6} dataTestId="email-list-loader">
    <Grid>
      <Row height="auto" width="100%">
        <Col>
          <Box p={6}>
            <Skeleton
              height="123px"
              width={{
                s: '100%',
                m: '30%',
              }}
            />
            <Box flex={1} flexDirection="column" ml={6}>
              <Skeleton height={16} isLarge mb={4} width="50%" />
              <Skeleton height={12} mb={4} width="30%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
            </Box>
          </Box>
        </Col>
      </Row>
    </Grid>
    <Grid>
      <Row height="auto" width="100%">
        <Col>
          <Box p={6}>
            <Skeleton
              height="123px"
              width={{
                s: '100%',
                m: '30%',
              }}
            />
            <Box flex={1} flexDirection="column" ml={6}>
              <Skeleton height={16} isLarge mb={4} width="50%" />
              <Skeleton height={12} mb={4} width="30%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
            </Box>
          </Box>
        </Col>
      </Row>
    </Grid>
    <Grid>
      <Row height="auto" width="100%">
        <Col>
          <Box p={6}>
            <Skeleton
              height="123px"
              width={{
                s: '100%',
                m: '30%',
              }}
            />
            <Box flex={1} flexDirection="column" ml={6}>
              <Skeleton height={16} isLarge mb={4} width="50%" />
              <Skeleton height={12} mb={4} width="30%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
              <Skeleton height={12} isLarge mb={3} width="100%" />
            </Box>
          </Box>
        </Col>
      </Row>
    </Grid>
  </Box>
);

export default EmailListLoader;
